<div *ngIf="canSeePage$ | async; else subscribeBlock" class="column gap" #page [class.fade-left]="fadeLeft$ | async"
     [class.fade-left-reverse]="fadeLeftReverse$ | async">
  <app-thematic-card [big]="true" [withoutTitle]="true" [thematic]="thematic"></app-thematic-card>

  <div class="space-between row">
    <h1 class="cooper title">{{ thematic.title | thematicField: thematic.slug:'title' }}</h1>
    <app-favorite-thematic [thematic]="thematic"/>
  </div>
  <p><strong>{{ thematic.resume | thematicField: thematic.slug:'resume' }}</strong></p>

  <div class="section row gap center-children-vertically pointer"  >
    <app-profile-icon (click)="goToSherpa()" *ngIf="train.sherpa" [profile]="train.sherpa" [tiny]="true" [editable]="false"></app-profile-icon>
    <div (click)="goToSherpa()" *ngIf="train.sherpa">
      <strong>{{ train.dynamic.dynamicType | translate }}</strong> <span *ngIf="train.sherpa">  {{ 'trains.with' | translate }} <u>{{train.sherpa.fullName}}</u></span>
    </div>
    <app-button *ngxPermissionsOnly="'admin'" (onClick)="modifySherpa()">{{ 'trains.detailsPage.selectSherpa' | translate }}</app-button>
    <ng-container *ngxPermissionsOnly="['admin', 'sherpa']">
      <span class="reference-id-wrapper" *ngIf="train?.referenceCode">N° {{ train.referenceCode }}</span>
    </ng-container>
  </div>


  <h2 class="section">{{ 'trains.detailsPage.sessions' | translate }}</h2>
  <div class="wrap">
    <div *ngFor="let session of train.sessions; let index = index;" [class.success]="index < train.currentSessionIndex" [class.current]="index === train.currentSessionIndex" class="bubble column center-children"
        [class.pointer]="isSherpaOrAdminWatching"
         (click)="modifySessionDate(index)">
      <strong class="tiny-margin-bottom">{{ sessionLabel(index) }}</strong>
      <p>{{ formatSessionDate(session.date) }}</p>
      <span>{{ 'trains.detailsPage.atTime' | translate:{ time: formatTime(session.date, 'h') } }}</span>
      <div class="color-white icon center-children" [class.success]="index < train.currentSessionIndex" [class.current]="index === train.currentSessionIndex">
        <app-icon class="color-white"  [type]="index < train.currentSessionIndex ? 'check' : 'clock'" />
      </div>
    </div>
  </div>

  <h2 class="section">{{ 'trains.detailsPage.participants' | translate }}</h2>
  <div class="wrap">
    <div *ngFor="let membership of train.memberShips" class="bubble column center-children"
         [class.pointer]="isSherpaOrAdminWatching" (click)="goToTalkerDetails(membership.user.id)">
      {{ membership.user.id === userId ? ('common.you' | translate) : membership.user.title}}
    </div>
  </div>

  <h2 class="section">{{ 'trains.detailsPage.whichDynamic' | translate }}</h2>
  <app-dynamics class="dynamics" [dynamics]="[train.dynamic]" [canValidate]="false"/>


  <div *ngIf="thematic.testimonials?.length">
    <h2 class="margin-bottom-xl margin-top">{{ 'trains.detailsPage.testimonials' | translate }}</h2>
    <app-slider *ngIf="thematic.testimonials" [items]="thematic.testimonials">
      <ng-template #slide let-item>
        <div class="testimonial" [class]="categorySlug">
          <div class="testimonial-content">
            <p class="margin-bottom">{{item.description}}</p>
            <p><strong>{{item.author}}</strong></p>
          </div>
        </div>
      </ng-template>
    </app-slider>
  </div>


  <div *ngIf="thematic.keyNumbers?.length">
    <h2>{{ 'trains.detailsPage.keyNumbers' | translate }}</h2>
    <div class="wrap gap">
      <div class="column margin-right" *ngFor="let keyNumber of thematic.keyNumbers">
        <p class="key-number cooper text-xl" [class]="categorySlug">{{keyNumber.stringNumber}}</p>
        <div class="key-number-description">{{keyNumber.description}}</div>
      </div>
    </div>
  </div>

  <div class="section" *ngxPermissionsExcept="['admin']">
    <a class="leave-button" [title]="'trains.detailsPage.leave' | translate" *ngIf="canLeave"
                (click)="leaveTrain()">{{ 'trains.detailsPage.leave' | translate }}
    </a>
  </div>
</div>
<ng-template #subscribeBlock>
  <app-subscribe-page></app-subscribe-page>
</ng-template>
